var _excluded = ["backgroundColor", "foregroundColor", "children"];
var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/SkeletonLoader/index.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @deprecated - SkeletonLoader has been moved to Wrench
 * https://github.com/mntv-web-experience/wrench
 *
 * It will be removed from webassets in the future so please update any imports
 * to now pull from wrench. Note you may need to setup a ThemeProvider and migrate
 * the page from legacy wds-react to new wrench.
 */

/**
 * HOW TO USE
 *
 * use create-content-loader to generate the desired skeleton svg:
 * https://danilowoz.com/create-content-loader/
 *
 * How it works:
 * 1) get dimensions of component to skeleton and put into create-content-loader
 * 2) use best guess estimates to mock out placements for all elements you
 *  want to show in the skeleton
 * 3) transfer this to code
 * 4) load page and check the position/size for each element
 * Adjust position in code as necessary
 * 5) rinse and repeat until you hit your desired level of pixel perfection
 */

import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'react-jss';
import { WebAssetsThemeWrapper } from '../../theme';
// https://github.com/danilowoz/react-content-loader/issues/194
import InitialComponent from './InitialComponent';
export var DEFAULT_COLOR = '#6B787A';
var SkeletonLoaderContent = function SkeletonLoaderContent(props) {
  var _theme$palette, _theme$palette$second, _theme$palette2, _theme$palette2$secon;
  var theme = useTheme();
  var backgroundColor = props.backgroundColor,
    foregroundColor = props.foregroundColor,
    children = props.children,
    other = _objectWithoutProperties(props, _excluded);
  var bgColor = backgroundColor || (theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$second = _theme$palette.secondary) === null || _theme$palette$second === void 0 ? void 0 : _theme$palette$second.main) || DEFAULT_COLOR;
  var fgColor = foregroundColor || (theme === null || theme === void 0 ? void 0 : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$secon = _theme$palette2.secondary) === null || _theme$palette2$secon === void 0 ? void 0 : _theme$palette2$secon.main) || DEFAULT_COLOR;
  return /*#__PURE__*/React.createElement(ContentLoader, Object.assign({
    backgroundColor: bgColor,
    foregroundColor: fgColor
  }, other, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }), children || /*#__PURE__*/React.createElement(InitialComponent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 20
    }
  })));
};
var SkeletonLoader = function SkeletonLoader(props) {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(SkeletonLoaderContent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 5
    }
  })));
};
SkeletonLoader.defaultProps = {
  children: null,
  // background
  backgroundColor: '',
  backgroundOpacity: 0.08,
  // animation
  foregroundColor: '',
  foregroundOpacity: 0.18,
  // speed
  speed: 2
};
export default SkeletonLoader;
//# sourceMappingURL=index.js.map